import http from '../utils/request'

export const getConnections = () => http.get('/database/connections')
export const executeSql = (data) => http.post('/database/execute', data)
export const getSchema = (connectionId) => http.get('/database/schema', { params: { connectionId } })
export const getTableDetail = (connectionId, tableName) => http.get('/database/table-detail', { params: { connectionId, tableName } })
export const getViewDefinition = (connectionId, viewName) => http.get('/database/view-definition', { params: { connectionId, viewName } })
export const getProcedureDefinition = (connectionId, procName) => http.get('/database/procedure-definition', { params: { connectionId, procName } })
